import _ from 'lodash'
import XLSX from 'xlsx'
import XLSXS from 'xlsx-style'
import {saveAs} from 'file-saver'

export const getInfo = () => {
  if (sessionStorage.getItem('iw_u') === null) return {}
  let res = JSON.parse(decodeURIComponent(atob(sessionStorage.getItem('iw_u'))))
  return res
}

export const isLogin = () => {
  if (sessionStorage.getItem('iw_u') === null) {
    return false
  }

  return true
}

export const isInterPlay = () => {
  let str = JSON.parse(decodeURIComponent(atob(sessionStorage.getItem('iw_c')))).nm
  if (str.indexOf('라이브') > -1) return false
  if (str.indexOf('인터플레이') > -1) return true
  if (str.indexOf('PIP') > -1) return true
  if (str === '홈랩 기절베개 7월 캠페인') return true
  return false
}

export const isMobile = () => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile Safari|Mobile/i.test(navigator.userAgent)) { // 모바일 접속 체크
    return true
  }

  return false
}

export const numberWithCommas = (x) => {
  if (x === undefined) return 0
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
export const checkData = (x) => { // 입력값이 float, int, string 인지 check - float면 .아래 두자리만 표시
  let value = x * 1
  if (!isNaN(value) && (value !== parseInt(value))) {
    value = (value > 100) ? 100.0 : value
    return value.toFixed(1)
  }
  if (value === parseInt(value)) return value.toFixed(0)
  return x
}
export const parseDataType = (x) => { // 입력값 체크 후 소수점 자리, 천단위 표시
  let result = checkData(x)
  result = numberWithCommas(result)

  return result
}
export const parseData = (data, key) => {
  if (key.indexOf('play_Q') > -1 || key.indexOf('play_sec_avg') > -1 || key.indexOf('end_rate') > -1) key = 'playQ'
  if (key.indexOf('rate') > -1) key = 'rate'

  switch (key) {
    case 'ymd':
      return data
    case 'ctr':
      return (data === 0 || data === null || data === '' || isNaN(data)) ? 0 : data.toFixed(2)
    case 'vtr':
    case 'rate':
      return (data === 0 || data === null || data === '' || isNaN(data)) ? 0 : data.toFixed(1)
    case 'uv_cnt':
    case 'playQ':
      return data === '' ? ' ' : parseDataType(data)
    case 'budget_amt':
      return !data ? data : parseDataType(parseInt(data))
    default :
      return parseDataType(data)
  }
}
export const checkUser = (custKnd) => { // 로그인한 유저 타입 확인 인터웍스, 랩사 - all true, 에이전시 - a만 true, client - all false
  switch (custKnd) {
    case 'C':
      return {
        a: false,
        l: false
      }
    case 'A':
      return {
        a: true,
        l: false
      }
    case 'L':
    case 'S':
      return {
        a: true,
        l: true
      }
    default:
      return
  }
}

export const dateSplit = (str) => {
  str = str + ''
  let y = str.substr(0, 4)
  let m = str.substr(4, 2)
  let d = str.substr(6, 2)

  return {
    y: y,
    m: m,
    d: d
  }
}
export const parseDate = (str) => { // 20170101 형태로 받아서 new Date() 리턴
  let date = dateSplit(str)
  return new Date(date.y + '-' + date.m + '-' + date.d)
}
export const restoreDate = (date) => { // 20170101 형태로 받아서 new Date() 리턴
  let y = date.getFullYear() + ''
  let m = date.getMonth() + 1
  let d = date.getDate()
  return y + (m < 10 ? '0' + m : m) + (d < 10 ? '0' + d : d)
}
export const parseDateFormat = (str) => { // 20170101 형태로 받아서 2017-01-01 리턴
  if (str === undefined) return ''
  let date = dateSplit(str)
  return date.y + '-' + date.m + '-' + date.d
}

export const checkCampaignYmd = (str) => { // 캠페인 날짜 확인 - 시작일로부터 하루이상 지나지 않음 false
  let date = dateSplit(str)
  date.d = date.d * 1 + 1

  let frYmd = new Date(date.y, date.m - 1, date.d)
  let today = new Date()

  if (frYmd < today) return true
  return false
}

export const subListName = (info, tab) => {
  switch (tab) {
    case 'contract':
      return getDataName(info, tab) + ' (' + info.dp_knd_nm + ')'
    case 'creativeGroup':
      return getDataName(info, tab) + ' (' + info.ad_knd_nm + ')'
    default:
      return getDataName(info, tab)
  }
}
export const getDataName = (data, tab) => { // 하나의 상품, 사이즈, 소재 명 추출
//   const setCreativeKrNm = (d) => {
//     const dataSplit = d.creative_nm.split('/')
//     return d.creative_kr_nm + ' (' + dataSplit[dataSplit.length - 1] + ')'
//   }
  switch (tab) {
    case 'contract':
      return data.ad_knd_nm
    case 'size':
      return data.size_nm
    case 'creative':
      return setCreativeNm(data)
    case 'creativeGroup':
      return data.creative_kr_nm ? data.creative_kr_nm : data.group_nm
    case 'geo':
      return data.geo_nm
    default:
      return ''
  }
}

export const getSize = (adKnd, creativeNm) => {
  switch (adKnd) {
    case 'OHIP':
      return 'M640_360_FULL'
    case 'SOHIP':
      return 'M300_230_PLUS'
    case 'IP':
      if (creativeNm.split('/')[3].trim().replace(/(.png|.jpg|.jpeg|.gif|.mp4)$/, '') === '970_250') return '970_250_FULL'
      else return '640_360_FULL'
    case 'SIP':
      if (creativeNm.split('/')[3].trim().replace(/(.png|.jpg|.jpeg|.gif|.mp4)$/, '') === '970_250') return '970_250_PLUS'
      else return '640_360_PLUS'
    case 'FIP':
      return '640_360_PERF'
    case 'FOHIP':
      return 'M640_360_PERF'
    case 'DIP':
      return '640_360_SAVE'
    case 'DOHIP':
      return 'M640_360_SAVE'
    case 'C06OHIP':
      return 'M640_360_06'
    case 'C06IP':
      return '640_360_06'
    case 'C15IP':
      return '640_360_15'
    case 'C15OHIP':
      return 'M640_360_15'
    case 'EX2':
      return 'P300_250'

    default :
      return ''
  }
}

export const getTargeting = (nm) => {
  if (nm === undefined) return
  const targeting = nm.split('/')[1]
  switch (targeting) {
    case 'CM':
      return '문맥매칭'
    case 'CM+':
      return '문맥매칭'
    case 'GT':
      return '지역매칭'
    case 'RT':
      return '리타겟팅'
    case 'AT':
      return '오디언스'
    case 'NK':
      return '비매칭'
    default :
      return '비매칭'
  }
}

export const whatKindOfCreative = (adKnd) => {
  switch (adKnd) {
    case 'OHIP':
      return '풀스크린(모바일)'
    case 'SOHIP':
      return '브랜드PLUS(모바일)'
    case 'IP':
      return '풀스크린'
    case 'SIP':
      return '브랜드PLUS'
    case 'FIP':
      return '퍼포먼스'
    case 'FOHIP':
      return '퍼포먼스(모바일)'
    case 'DIP':
      return '세이브'
    case 'DOHIP':
      return '세이브(모바일)'
    case 'C06IP':
      return '쇼츠06'
    case 'C06OHIP':
      return '쇼츠06(모바일)'
    case 'C15IP':
      return '쇼츠15'
    case 'C15OHIP':
      return '쇼츠15(모바일)'
    case 'EX2':
      return '팝업'
    case 'XIP':
      return 'PC BOX'
    default :
      return '배너'
  }
}
export const setCreativeKr = (data) => {
  return data.creative_kr_nm
}
export const setCreativeKrNmkr = (adKnd) => {
  switch (adKnd) {
    case 'OHIP':
    case 'EOHIP' :
    case 'AOHIP':
    case 'GOHIP':
    case 'VOHIP':
    case 'VEOHIP' :
    case 'VGOHIP':
    case 'VAOHIP':
    case 'CVOHIP':
    case 'CVAOHIP':
    case 'CVGOHIP':
      return 'OHIP'
    case 'SOHIP':
    case 'ESOHIP' :
    case 'ASOHIP':
    case 'GSOHIP':
    case 'VSOHIP':
    case 'VESOHIP' :
    case 'VGSOHIP':
    case 'VASOHIP':
    case 'CVSOHIP':
    case 'CVASOHIP':
    case 'CVGSOHIP':
      return 'SOHIP'
    case 'FOHIP':
    case 'EFOHIP' :
    case 'AFOHIP':
    case 'GFOHIP':
    case 'VFOHIP':
    case 'VEFOHIP' :
    case 'VGFOHIP':
    case 'VAFOHIP':
    case 'CVFOHIP':
    case 'CVAFOHIP':
    case 'CVGFOHIP':
      return 'FOHIP'
    case 'DOHIP':
    case 'VDOHIP':
    case 'VEDOHIP' :
    case 'VGDOHIP':
    case 'VADOHIP':
      return 'DOHIP'
    case 'C06OHIP':
    case 'C06EOHIP' :
    case 'C06AOHIP':
    case 'C06GOHIP':
      return 'C06OHIP'
    case 'C15OHIP':
    case 'C15EOHIP' :
    case 'C15AOHIP':
    case 'C15GOHIP':
      return 'C15OHIP'
    case 'C06IP':
    case 'C06EIP' :
    case 'C06AIP':
    case 'C06GIP':
      return 'C06IP'
    case 'C15IP':
    case 'C15EIP' :
    case 'C15AIP':
    case 'C15GIP':
      return 'C15IP'
    case 'IP':
    case 'EIP' :
    case 'AIP':
    case 'GIP':
    case 'VIP':
    case 'VEIP' :
    case 'VAIP':
    case 'VGIP':
    case 'CVIP':
    case 'CVAIP':
    case 'CVGIP':
      return 'IP'
    case 'SIP':
    case 'ESIP' :
    case 'ASIP':
    case 'GSIP':
    case 'VSIP':
    case 'VESIP' :
    case 'VASIP':
    case 'VGSIP':
    case 'CVSIP':
    case 'CVASIP':
    case 'CVGSIP':
      return 'SIP'
    case 'FIP':
    case 'EFIP' :
    case 'AFIP':
    case 'GFIP':
    case 'VFIP':
    case 'VEFIP' :
    case 'VAFIP':
    case 'VGFIP':
    case 'CVFIP':
    case 'CVAFIP':
    case 'CVGFIP':
      return 'FIP'
    case 'DIP':
    case 'VDIP':
    case 'VEDIP' :
    case 'VADIP':
    case 'VGDIP':
      return 'DIP'
    case 'EX2':
    case 'EEX2' :
    case 'AEX2':
    case 'GEX2':
    case 'CVEX2':
    case 'CVAEX2':
    case 'CVGEX2':
      return 'EX2'
    case 'XIP':
    case 'EXIP' :
    case 'AXIP':
    case 'GXIP':
      return 'XIP'
    default :
      return 'BA'
  }
}

export const setCreativeNm = (data) => {
  if (data.creative_nm === undefined) return
  return (
    whatKindOfCreative(setCreativeKrNmkr(data.ad_knd)) +
    '_' +
    getTargeting(data.creative_nm) +
    '_' +
    (data.creative_kr_nm
      ? setCreativeKr(data)
      : data.creative_nm.split('/')[2]) +
    '_' +
    data.creative_nm
      .split('/')[3]
      .trim()
      .replace(/(.png|.jpg|.jpeg|.gif|.mp4)$/, '')
  )
}
export const getStatusClass = (status) => { // 캠페인 상태(0: 전체, 1: 예정, 2: 진행, 3: 홀딩, 4: 완료, 5: 중간정산)별 클래스 부여
  switch (status) {
    case '2':
      return 'text-blue'
    case '3':
    case '5':
      return 'text-red'
    case '4':
      return 'text-green'
    default:
      return ''
  }
}

export const statusText = (status) => { // 캠페인 상태별 표시할 텍스트
  switch (status * 1) {
    case 0: return '전체'
    case 2: return '진행'
    case 3: return '홀딩'
    case 4: return '완료'
    case 5: return '중간정산'
    default: return
  }
}

export const getTemp = (tab) => {
  let a = {
    ad_knd: null,
    ad_knd_nm: null,
    click_cnt: 0,
    ctr: 0,
    dp_knd: null,
    dp_knd_nm: null,
    end_cnt: null,
    end_rate: null,
    imp_cnt: 0,
    play_cnt: null,
    view_cnt: null,
    vtr: null,
    ymd: '',
    budget_amt: 0
  }
  let b = {
    click_cnt: 0,
    creative_nm: null,
    ctr: 0,
    end_cnt: null,
    end_rate: null,
    imp_cnt: 0,
    play_cnt: null,
    view_cnt: null,
    vtr: null,
    ymd: '',
    budget_amt: 0
  }
  let c = {
    ad_knd: null,
    ad_knd_nm: null,
    click_cnt: 0,
    ctr: 0,
    end_cnt: null,
    end_rate: null,
    imp_cnt: 0,
    play_cnt: null,
    size_nm: null,
    view_cnt: null,
    vtr: null,
    ymd: '',
    budget_amt: 0
  }
  let d = {
    ad_knd: null,
    ad_knd_nm: null,
    click_cnt: 0,
    ctr: 0,
    geo_nm: null,
    imp_cnt: 0,
    ymd: '',
    budget_amt: 0
  }
  let e = {
    ad_knd: null,
    ad_knd_nm: null,
    click_cnt: 0,
    ctr: 0,
    group_nm: null,
    imp_cnt: 0,
    ymd: '',
    budget_amt: 0
  }
  switch (tab) {
    case 'contract': return a
    case 'creative': return b
    case 'creativeGroup': return e
    case 'size': return c
    case 'geo': return d
  }
}

export const getContractTotal = (contractList, type, isInter) => { // 상품별 데이터 테이블 합계 (상품별 리포트 합계)
  let total = {
    imp_cnt: 0,
    click_cnt: 0,
    ctr: 0,
    day_rate: 0,
    imp_rate: 0,
    budget_amt: 0
  }
  let length = contractList.length
  // 기본적으로 들어가는 합계 데이터
  // _.sumBy(arr, 'key' or fn) -> fn에서 사용하거나 받은 key값들의 합 리턴
  if (contractList.length === 0) {
    return {
      imp_cnt: 0,
      click_cnt: 0,
      ctr: 0,
      day_rate: 0,
      imp_rate: 0,
      view: 0,
      vtr: 0,
      budget_amt: 0
    }
  }
  const isCampaignType = () => {
    switch (type) {
      case 'CPCV' :
        return true
      case 'CPV' :
        return false
      default :
        if (type.indexOf('CV') > -1) return true // 'IP', 'AIP', 'OHIP', 'JIP', 'HIP'
        else return false
    }
  }
  total.imp_cnt = _.sumBy(contractList, function (o) { return o.imp_cnt * 1 })
  total.click_cnt = _.sumBy(contractList, function (o) { return o.click_cnt * 1 })
  total.day_rate = contractList[0].day_rate.toFixed(1)
  total.imp_rate = (_.sumBy(contractList, function (o) { return o.imp_rate * 1 })) / length
  total.ctr = total.click_cnt / total.imp_cnt * 100
  total.budget_amt = _.sumBy(contractList, function (o) { return o.budget_amt * 1 })
  if (isInter) {
    total.view = _.sumBy(contractList, function (o) { return o.view_cnt * 1 })
    total.play_cnt = _.sumBy(contractList, function (o) { return o.play_cnt * 1 })
    total.vtr =
      (total.view / (isCampaignType() ? total.play_cnt : total.imp_cnt)) * 100
    total.vtr = isNaN(total.vtr) ? 0 : total.vtr
  }
  // cvip, cvaip에서 필요한 데이터
  if (type.indexOf('CV') > -1) {
    total.vc = _.sumBy(contractList, function (o) { return o.cpvc * 1 })
    total.vc = isNaN(total.vc) ? 0 : total.vc
  }
  if (type === 'CPCV') {
    total.vc = _.sumBy(contractList, function (o) { return o.cpcv * 1 })
    total.vc = isNaN(total.vc) ? 0 : total.vc
  }
  if (type === 'CVPIP' || type === 'PIP') {
    total.skip = _.sumBy(contractList, function (o) { return o.skip_cnt * 1 })
    total.skip = isNaN(total.skip) ? 0 : total.skip
  }
  total.ctr = isNaN(total.ctr) ? 0 : total.ctr
  return total
}

export const getBudgetAmt = (list, name, data) => {
  let total = { budget_amt: 0 }
  const sameAdKndNm = list.filter((item) => {
    return item.ad_knd_nm === data.ad_knd_nm
  })
  total.budget_amt = _.sumBy(sameAdKndNm, function (o) {
    return o.budget_amt * 1
  })
  return total.budget_amt
}

export const exprtExcel = (tableNames, cname) => {
  let names = [
    ['상품별 리포트', '일자별 리포트', '상품|일자별 리포트'],
    ['사이즈별 리포트', '일자별 리포트', '사이즈|일자별 리포트'],
    ['소재별 리포트', '일자별 리포트', '소재|일자별 리포트'],
    ['소재그룹 그룹별 리포트', '일자별 리포트', '소재그룹|일자별 리포트'],
    ['지역별 리포트', '일자별 리포트', '지역|일자별 리포트']
  ]
  if (!isInter) names.push()
  var wb = XLSX.utils.book_new()
  let isInter = isInterPlay()

  for (let i = 0; i < tableNames.length; i++) {
    let tables = tableNames[i].split('|')
    let tbl
    let ws
    // top table
    tbl = document.getElementById(tables[0])
    ws = XLSX.utils.table_to_sheet(tbl)
    XLSX.utils.book_append_sheet(wb, ws, names[i][0])

    if (i === 0 && isInter) { // 인터플레이 상품별
      tbl = document.getElementById(tables[1])
      ws = XLSX.utils.table_to_sheet(tbl)
      XLSX.utils.book_append_sheet(wb, ws, names[i][1])

      // 인터플레이 상품/일자별
      tbl = '<table id="new_table">'
      for (let j = 2; j < tables.length; j++) {
        tbl += document.getElementById(tables[j]).innerHTML
        tbl = tbl.replace(/<thead[^>]*>|<\/thead>/g, '')
        tbl = tbl.replace(/<tbody[^>]*>|<\/tbody>/g, '')
        tbl = tbl.replace(/<tfoot[^>]*>|<\/tfoot>/g, '')
      }
      tbl += '</table>'
      document.getElementById('temp_table').innerHTML = tbl
      tbl = document.getElementById('new_table')
      ws = XLSX.utils.table_to_sheet(tbl)
      XLSX.utils.book_append_sheet(wb, ws, names[i][2])
    } else if (i === 2 && isInter) { // 인터플레이 소재/일자별
      tbl = '<table id="new_table">'
      for (let j = 1; j < tables.length; j++) {
        tbl += document.getElementById(tables[j]).innerHTML
        tbl = tbl.replace(/<thead[^>]*>|<\/thead>/g, '')
        tbl = tbl.replace(/<tbody[^>]*>|<\/tbody>/g, '')
        tbl = tbl.replace(/<tfoot[^>]*>|<\/tfoot>/g, '')
      }
      tbl += '</table>'
      document.getElementById('temp_table').innerHTML = tbl
      tbl = document.getElementById('new_table')
      ws = XLSX.utils.table_to_sheet(tbl)
      XLSX.utils.book_append_sheet(wb, ws, names[i][2])
    } else { // 일반 일자별, 사이즈/일자별, 소재/일자별
      // bottom left table
      if (i === 0) {
        tbl = document.getElementById(tables[1])
        ws = XLSX.utils.table_to_sheet(tbl)
        //   let last = (ws['!ref'].split(':')[1].substr(0, 1)).charCodeAt(0) - 65
        let lastIndex = ws['!ref'].split(':')[1].substr(1) * 1
        let res = []
        for (let i = 1; i <= lastIndex; i++) {
          if (ws['A' + i] !== undefined && ws['A' + i].t === 'n') {
            res.push(i)
          }
        }
        XLSX.utils.book_append_sheet(wb, ws, names[i][1])
      }
      //   for (let i = 0; i <= last; i++) {
      //     for (let j = 0; j < res.length; j++) {
      //       // 배경색 바꾸기
      //       let col = String.fromCharCode(65 + i)
      //       ws[col + res[j]].s = {fill: {patternType: 'solid', fgColor: {rgb: 'FFB0E0E6'}}}
      //     }
      //   }

      // bottom right table
      tbl = '<table id="new_table">'
      for (let j = 2; j < tables.length; j++) {
        tbl += document.getElementById(tables[j]).innerHTML
        tbl = tbl.replace(/<thead[^>]*>|<\/thead>/g, '')
        tbl = tbl.replace(/<tbody[^>]*>|<\/tbody>/g, '')
        tbl = tbl.replace(/<tfoot[^>]*>|<\/tfoot>/g, '')
      }
      tbl += '</table>'
      document.getElementById('temp_table').innerHTML = tbl
      tbl = document.getElementById('new_table')
      ws = XLSX.utils.table_to_sheet(tbl)
      XLSX.utils.book_append_sheet(wb, ws, names[i][2])
    }
  }

  var wbout = XLSXS.write(wb, {bookType: 'xlsx', type: 'binary'})
  let saveExcel = (s) => {
    let buf = new ArrayBuffer(s.length)
    let view = new Uint8Array(buf)
    for (var i = 0; i !== s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
    return buf
  }
  let date = dateSplit(restoreDate(new Date()))
  let wbName = date.y + '_' + date.m + '_' + date.d + '_' + cname + '.xlsx'
  saveAs(new Blob([saveExcel(wbout)], {type: 'application/octet-stream'}), wbName)
}

export const checkCampaignType = (isIp, camNm, contract) => { // 상품별 페이지 -> 일반상품, 인터플레이 구분
  if (!isIp || camNm === undefined) {
    return 'BASE'
  }

  let adKnd = contract.length !== 0
    ? contract[0].ad_knd : 'IP'
  switch (adKnd) {
    case 'CVIP' :
    case 'CVAIP' :
    case 'CVGIP' :
    case 'CVGSIP' :
    case 'CVASIP' :
    case 'CVOHIP' :
    case 'CVAOHIP' :
    case 'CVGOHIP' :
    case 'CVGSOHIP' :
    case 'CVASOHIP' :
      return 'CV'
    case 'HIP':
      return 'HIP'
    case 'PIP':
      return 'PIP'
    case 'CVPIP':
      return 'CVPIP'
    case 'LBIP':
      return 'LBIP'
    case 'C06IP':
    case 'C06EIP':
    case 'C06OHIP':
    case 'C06SOHIP':
    case 'C06AIP':
    case 'C06ASIP':
    case 'C06AOHIP':
    case 'C06ASOHIP':
    case 'C06GIP':
    case 'C06GOHIP':
    case 'C06EOHIP':
    case 'C06GSOHIP':
    case 'C15IP':
    case 'C15EIP':
    case 'C15EOHIP':
    case 'C15GIP':
    case 'C15GOHIP':
    case 'C15GSOHIP':
    case 'C15AIP':
    case 'C15AOHIP':
    case 'C15ASOHIP':
    case 'C15OHIP':
      return 'CPCV'
    case 'VIP':
    case 'VEIP':
    case 'VEFOHIP':
    case 'VEOHIP':
    case 'VESOHIP':
    case 'VESIP':
    case 'VEFIP':
    case 'VSIP':
    case 'VAIP':
    case 'VGIP':
    case 'VASIP':
    case 'VGSIP':
    case 'VAFIP':
    case 'VADIP':
    case 'VSFIP':
      return 'CPV' // <- CPV상품인데 CPM 처럼
    case 'XIP':
    case 'EXIP':
    case 'AXIP':
    case 'GXIP':
      return 'XIP'
    default : // 'IP', 'AIP', 'OHIP', 'JIP', 'HIP'
      return 'IP'
  }
}

export const currentIPView = (campaignType) => {
  switch (campaignType) {
    case 'BASE':
      return 'ContractBaseTable'
    case 'CV':
    case 'CVPIP':
      return 'ContractInterPlayCV'
    case 'CPCV':
      return 'ContractInterPlayCPCV'
    default :
      return 'ContractInterPlay'
  }
}



// WEBPACK FOOTER //
// ./src/assets/func.js